// Generate a random number between 0 and 255
export const randRGB = () => Math.round(Math.random() * 255);

export default {};
